import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ExterneKlachtenForm from "./ExterneKlachtenForm";
import KlachtBevestigingForm from "./KlachtBevestigingForm";
import AutoBindComponent from "../common/AutoBindComponent";
import Section from "../common/Section";
import redirector from "../../util/redirector";
import ExterneKlachtenPageHelper from "./ExterneKlachtenPageHelper";
import * as FilesHelperUtil from "../common/FilesHelperUtil";
import * as ajaxActions from "../../actions/ajaxCounterActions";

class ExterneKlachtenPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            klachtenModel: {
                id: null,
                voornaam: "",
                achternaam: "",
                organisatie: "",
                telefoon: "",
                gsm: "",
                email: "",
                bevestigEmail: "",
                datum: "",
                omschrijving: "",
				adres: {
					id: null,
					adresObjectId: null,
					displayName: "",
					gemeenteId: "",
					gemeente: "",
					postCode: "",
					straatId: 0,
					straatNaam: "",
					huisNummer: "",
					busNummer: "",
					latitude: null,
					longitude: null
				}
            },
            klachtenBijlage: [],
            hasUnsavedDocumentChanges: false,
            fileSessionId: null,
            errors: [],
            klachtSent: false,
			sendButtonDisabled: true
        };

        this.filesHelper = null;
        this.pageHelper = new ExterneKlachtenPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnSave = () => this.pageHelper.save();
    handleOnDropFile = (propertyName, files) => this.pageHelper.addBijlage(FilesHelperUtil.onDropFiles(this.state[propertyName], propertyName, files));
    handleOnRemoveFile = (propertyName, fileName) => this.pageHelper.removeBijlage(FilesHelperUtil.onRemoveFile(this.state[propertyName], propertyName, fileName));
	handleOnAdresSave = (adres) => this.pageHelper.saveAdres(adres);
	handleOnCaptchaVerified = (verified) => this.pageHelper.onCaptchaVerified(verified);

    render() {
        if (!!this.filesHelper === false) return null;

        return (
            <Section>
                {this.state.klachtSent ?
                    <KlachtBevestigingForm /> :
                    <ExterneKlachtenForm
                        klachtenModel={this.state.klachtenModel}
                        onAdresSave={this.handleOnAdresSave}
                        onChange={this.handleOnChange}
                        onSave={this.handleOnSave}
                        onDropFiles={this.handleOnDropFile}
                        onRemoveFile={this.handleOnRemoveFile}
                        onCaptchaVerified={this.handleOnCaptchaVerified}
                        fileDownloadUrl={this.filesHelper.getFileDownloadUrl()}
                        filesComponent={this.state.klachtenBijlage}
                        sendButtonDisabled={this.state.sendButtonDisabled}
                        errors={this.state.errors}
                    />
                }
            </Section>
        );
    }
}

ExterneKlachtenPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExterneKlachtenPage);
